import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Phone } from "lucide-react";
import Seo from "../components/Seo";
import { track } from "../lib/api";

export default function ThankYou() {
  useEffect(() => { track("conversion", { type: "lead" }); }, []);
  return (
    <>
      <Seo title="Thank You | Car To Cash" description="Thanks for your enquiry. We'll be in touch shortly with your free valuation." canonical="https://cartocash.com.au/thank-you" />
      <section className="mx-auto max-w-2xl px-4 sm:px-6 py-24 text-center" data-testid="thank-you">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-brand-gold/15">
          <CheckCircle2 className="h-11 w-11 text-brand-gold" />
        </div>
        <h1 className="mt-6 font-display text-4xl font-black text-brand-navy">Thanks — we've got it!</h1>
        <p className="mt-4 text-lg text-brand-muted">
          One of our buyers will be in touch shortly with your free, no-obligation valuation. Keep an eye on your phone and inbox.
        </p>
        <div className="mt-8 rounded-2xl border border-brand-line bg-brand-surface p-6 text-left">
          <h2 className="font-display font-extrabold text-brand-navy">What happens next</h2>
          <ol className="mt-3 space-y-2 text-brand-muted">
            <li>1. We review your details and call you back.</li>
            <li>2. We arrange a quick ~10 minute inspection (we can come to you).</li>
            <li>3. You get paid on the spot by cash or EFT.</li>
          </ol>
        </div>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <a href="tel:0431206206" onClick={() => track("phone_tap", { where: "thankyou" })} className="inline-flex items-center gap-2 rounded-full bg-brand-navy px-7 py-4 font-bold text-white hover:bg-brand-navy2 transition-colors" data-testid="ty-call-btn"><Phone className="h-4 w-4" /> Call 0431 206 206</a>
          <Link to="/" className="inline-flex rounded-full border-2 border-brand-line px-7 py-4 font-bold text-brand-navy hover:bg-brand-surface transition-colors">Back to home</Link>
        </div>
      </section>
    </>
  );
}
